<main class="flex min-h-screen items-center justify-center bg-slate-50 px-6 text-center text-sm font-semibold text-slate-600" role="status" aria-live="polite" data-testid="data-manager-entry">
    <div>
        <div *ngIf="!redirectFailed" data-testid="data-manager-redirecting">
            <i class="fa-solid fa-spinner fa-spin mr-2 text-violet-700" aria-hidden="true"></i>
            데이터셋 관리 화면으로 이동 중입니다.
        </div>
        <div *ngIf="redirectFailed" class="rounded-xl border border-amber-200 bg-white p-6 shadow-sm" data-testid="data-manager-redirect-fallback">
            <p class="text-slate-800">데이터셋 관리 화면으로 자동 이동하지 못했습니다.</p>
            <button type="button" (click)="retry()" class="mt-4 rounded-lg bg-violet-700 px-4 py-2 text-xs font-bold text-white">
                다시 이동하기
            </button>
            <a href="/page.xray/training?workspace=dataset" class="ml-2 inline-flex rounded-lg border border-slate-300 bg-white px-4 py-2 text-xs font-bold text-slate-700">
                직접 열기
            </a>
        </div>
    </div>
</main>
